// Canonical unit names for a location — used by swiper-mapping dropdowns
// so the options match the equipment actually configured for the wash.

export const unitOptions = (location) => {
  if (!location) return [{ value: 'Other', label: 'Other / Ignore' }];
  const opts = [];

  // Auto Wash(es)
  const numAuto = location.num_auto_washes || 0;
  if (numAuto <= 1) {
    opts.push({ value: 'Auto Wash', label: 'Auto Wash' });
  } else {
    for (let i = 1; i <= numAuto; i++) opts.push({ value: `Auto Wash ${i}`, label: `Auto Wash ${i}` });
  }

  // SS Bays
  for (let i = 1; i <= (location.num_ss_bays || 0); i++) {
    opts.push({ value: `SS Bay ${i}`, label: `SS Bay ${i}` });
  }

  // Vacuums
  for (let i = 1; i <= (location.num_vacuums || 0); i++) {
    opts.push({ value: `Vacuum ${i}`, label: `Vacuum ${i}` });
  }

  // Dog wash(es)
  const numDog = location.num_dog_washes || 0;
  if (numDog === 1) {
    opts.push({ value: 'Dog Wash', label: 'Dog Wash' });
  } else if (numDog > 1) {
    for (let i = 1; i <= numDog; i++) opts.push({ value: `Dog Wash ${i}`, label: `Dog Wash ${i}` });
  }

  // Vending machines by configured name (rare to have CC swipers, but harmless)
  for (const name of (location.vending_machine_names || [])) {
    const trimmed = (name || '').trim();
    if (trimmed) opts.push({ value: trimmed, label: `Vending — ${trimmed}` });
  }

  // Always available: 'Other' — for swipers we deliberately don't attribute.
  opts.push({ value: 'Other', label: 'Other / Ignore' });
  return opts;
};
